import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import React from "react";
import { BranchClassFeeEditTableRow } from "./BranchClassFeeEditTableRow";
import { CLASS_CAMP_IND, getLegacyTableType } from "./feeCourseKind";

export const BranchClassFeeEditTable = ({
  values,
  errors,
  touched,
  deleted,
  setDeleted,
}) => {
  // Only rendered for regular classes; doesn't need a fee row to exist.
  const TYPE = getLegacyTableType(CLASS_CAMP_IND);
  return (
    <span>
      <Table>
        <TableBody>
          {[
            { id: 4, value: "4 times a week" },
            { id: 8, value: "8 times a week" },
          ].map((bt) => {
            return (
              <BranchClassFeeEditTableRow
                key={bt.id}
                values={values}
                errors={errors}
                touched={touched}
                deleted={deleted}
                setDeleted={setDeleted}
                bt={bt}
                TYPE={TYPE}
              />
            );
          })}
        </TableBody>
      </Table>
    </span>
  );
};
